export default __webpack_public_path__ + "static/media/AprilSATPrepOptimized.029c5067.webp";